import { styled, Tab, Box, Button } from "@mui/material";

import starIcon from "../../assets/icons/icon_star.svg";

export const InteractiveButtonsRoot = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  color: "#000",
  position: "fixed",
  left: show ? 0 : "-100vw",
  top: "7vh",
  bottom: "auto",
  minWidth: "auto",
  width: "100vw",
  height: "auto",
  transition: "all ease-in-out 0.5s",
  zIndex: 1,
  pointerEvents: "auto",
  boxSizing: "border-box",
  background: "none",
  borderRadius: 0,
  border: "none",
  [theme.breakpoints.up("md")]: {
    left: show ? 0 : "-35vw",
    width: "35vw",
  },
  [theme.breakpoints.up("lg")]: {
    left: show ? 0 : "-25vw",
    width: "25vw",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100vw",
    height: "100%",
    background:
      "linear-gradient(90deg, rgba(255, 255, 255, 1) 60%, rgba(255, 255, 255, 0) 95%)",
    transition: "all linear 0.5s",
    top: 0,
    left: show ? "0" : "-100vw",
    zIndex: -1,
    [theme.breakpoints.up("md")]: {
      left: show ? "0" : "-40vw",
      width: "40vw",
      background:
        "linear-gradient(90deg, rgba(255, 255, 255, 1) 35%, rgba(255, 255, 255, 0) 95%)",
    },
    [theme.breakpoints.up("lg")]: {
      left: show ? "0" : "-50vw",
      width: "30vw",
    },
  },
}));

export const CustomTabs = styled(Box)(({ theme }) => ({
  zIndex: 3,
  padding: "1rem",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  overflowX: "hidden",
  width: "auto",
}));

export const CustomTab = styled(Tab)(({ theme, active }) => ({
  // color: "#000",
  color: active ? "#fff" : "#071A3D",
  zIndex: -1,
  minWidth: "16rem",
  minHeight: "6rem",
  width: "100%",
  padding: "0.5rem 0.5rem 0.5rem 3.2rem",
  transition:
    "all ease-in-out 0.3s, font-family 0.1s ease-out, font-size 0.1s ease-out",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  fontFamily: active
    ? '"Raleway", sans-serif'
    : '"Raleway", "Helvetica", "Arial", sans-serif',
  fontSize: active ? "2rem" : "1.75rem",
  fontWeight: active ? "500" : "300",
  textTransform: "initial",
  textAlign: "left",
  // borderBottom: "1px solid #fa0",
  borderBottom: "1px solid #071A3D",
  position: "relative",
  opacity: 1,
  cursor: active ? "initial" : "pointer",
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  "&:before": {
    content: "''",
    position: "absolute",
    width: active ? "100%" : 0,
    height: "100%",
    top: 0,
    left: 0,
    display: "block",
    zIndex: -1,
    // background: "#fa0",
    background: "#071A3D",
    transition: "all 0.3s ease-out",
  },
  ":hover": {
    "@media (hover: hover) and (pointer: fine)": {
      fontFamily: '"Raleway", sans-serif',
      fontSize: "2rem",
      color: "#fff !important",
      // color: "#000 !important",
      fontWeight: "500",
      "&:before": {
        width: "100%",
      },
    },
  },
}));

export const TabIcon = styled("img")(({ theme }) => ({
  width: 25,
  display: "block",
}));

export const CustomSeparator = styled(Box)(({ theme }) => ({
  zIndex: 5,
  width: 1,
  height: 20,
  // background: "#000",
  background: "#071A3D",
  margin: "0 0 7px 0",
  padding: 0,
  overflow: "hidden",
  display: "block",
  opacity: 0.25,
  [theme.breakpoints.up("md")]: {
    width: 0.5,
    margin: "0 1px",
    opacity: 0.5,
    height: 35,
  },
}));

export const TabContentWrapper = styled(Box)(({ theme, show }) => ({
  zIndex: 2,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  boxSizing: "border-box",
  left: 0,
  width: "100%",
  transition: show ? "all 0.5s ease-out" : "all 0.5s 0s ease-out",
  // transform: show ? "translateX(0)" : "translateX(105%)",
  border: "none",
  [theme.breakpoints.down("md")]: {
    bottom: "2vh",
  },
  [theme.breakpoints.down("sm")]: {
    bottom: "9rem",
  },
}));

export const TabContent = styled(Box)(({ theme }) => ({
  zIndex: 5,
  width: "100%",
  maxWidth: "100%",
  margin: 0,
  position: "relative",
  padding: 0,
  [theme.breakpoints.up("md")]: {
    margin: 0,
  },
  "@keyframes animationIn": {
    "0%": {
      transform: "translateX(20vw)",
      opacity: 0,
    },
    "80%": {
      transform: "translateX(0)",
      opacity: 1,
    },
    "100%": {
      transform: "translateX(20vw)",
      opacity: 1,
    },
  },
}));

export const TopTabs = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100vw",
  minWidth: 0,
  boxSizing: "border-box",
  padding: "5px 8px",
  margin: "0 auto 5px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  opacity: 1,
  transition: "all ease-in-out 0.5s",
  borderRadius: 3,
  zIndex: 0,
  [theme.breakpoints.up("sm")]: {
    width: "auto",
    padding: "5px 40px",
    borderRadius: 3,
    borderBottom: "none",
    justifyContent: "center",
    maskImage: "linear-gradient(black, transparent)",
  },
  [theme.breakpoints.up("md")]: {
    transform: "translateX(55px)",
    padding: "5px 40px 50px",
    overflow: "hidden",
    maxWidth: "100%",
    margin: "auto",
  },
  [theme.breakpoints.down("md")]: {
    "@media (orientation: landscape)": {
      marginBottom: 0,
    },
  },
}));

export const OptionName = styled("span")(({ theme }) => ({
  fontSize: 13,
  fontWeight: 400,
  position: "relative",
  color: "#24292b",
  marginBottom: 5,
  marginTop: 5,
  padding: "0 0 0 10px",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    padding: "0 20px",
  },
  [theme.breakpoints.up("md")]: {
    marginBottom: 5,
    marginTop: 0,
    transform: "none",
    padding: "0 15px 5px 25px",
  },
  [theme.breakpoints.down("lg")]: {
    "@media (orientation: portrait)": {
      paddingBottom: 10,
      marginTop: 0,
    },
  },
  [theme.breakpoints.down("md")]: {
    "@media (orientation: landscape)": {
      position: "absolute",
      zIndex: 5,
      top: "-0.3rem",
      left: "-0.7rem",
      padding: "2px 5px 2px 10px",
      margin: 0,
      fontSize: "12px",
      background: "rgba(36,41,43,0.9)",
      borderRadius: "0.2rem",
    },
  },
  "&::before": {
    content: '""',
    background: "#ed8733",
    position: "absolute",
    top: "50%",
    left: 0,
    width: "2px",
    height: "2px",
    borderRadius: "100%",
    [theme.breakpoints.up("sm")]: {
      left: "15px",
    },
    [theme.breakpoints.down("lg")]: {
      "@media (orientation: portrait)": {
        top: "30%",
      },
    },
    [theme.breakpoints.down("md")]: {
      "@media (orientation: landscape)": {
        left: "5px",
      },
    },
  },
}));

export const OptionList = styled(Box)(({ theme, length }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  padding: 0,
}));

export const OptionButton = styled(Box)(({ theme, active }) => ({
  zIndex: 3,
  position: "relative",
  padding: 0,
  pointerEvents: active ? "none" : "initial",
  cursor: !active ? "pointer" : "initial",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  marginTop: "1rem",
  width: "8rem",
  height: "8rem",
  [theme.breakpoints.up("lg")]: {
    // "@media (orientation: portrait)": {
    //   top: "30%",
    // },
    width: "10rem",
    height: "10rem",
  },
  "& span": {
    marginTop: 5,
    fontFamily: active
      ? '"Raleway", sans-serif'
      : '"Raleway", "Helvetica", "Arial", sans-serif',
    fontSize: "1.25rem",
    fontWeight: "300",
    textTransform: "initial",
    textAlign: "center",
    zIndex: 1,
    transition: "all 0.1s ease-out",
    // color: "#000",
    color: "#071A3D",
  },
}));

export const OptionButtonImg = styled(Box)(({ theme, active }) => ({
  width: "6.5rem",
  height: "6.5rem",
  padding: 0,
  position: "relative",
  boxSizing: "border-box",
  transition: "all 0.3s ease",
  zIndex: 0,
  "&::before": {
    content: '""',
    display: active ? "block" : "none",
    width: "110%",
    height: "110%",
    position: "absolute",
    top: "-5%",
    left: "-5%",
    // background: "#fa0",
    background: "#071A3D",
    borderRadius: "6px",
  },
  [theme.breakpoints.up("lg")]: {
    // "@media (orientation: portrait)": {
    //   top: "30%",
    // },
    width: "8rem",
    minHeight: "8rem",
  },
  "& img": {
    display: "block",
    position: "relative",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    margin: "auto",
    zIndex: 0,
    transition: "all 0.3s ease",
    borderRadius: "4px",
  },
  "&:hover": {
    "@media (hover: hover) and (pointer: fine)": {
      // border: "2px solid #000",
    },
  },
}));

export const OptionRoundButton = styled(Box)(({ theme, active }) => ({
  zIndex: 3,
  position: "relative",
  padding: 0,
  pointerEvents: active ? "none" : "initial",
  cursor: !active ? "pointer" : "initial",
  minWidth: "10rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    minWidth: "8rem",
  },
  "&::before": {
    content: "''",
    position: "absolute",
    width: "1.5rem",
    height: "1.5rem",
    top: "-0.75rem",
    left: "calc(50% - 3rem)",
    opacity: active ? 1 : 0.5,
    filter: "brightness(0) invert(1)",
    display: active ? "block" : "none",
    backgroundImage: `url(${starIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundPosition: "center",
    transition: "all 0.3s ease-out",
  },
  "& span": {
    fontFamily: active
      ? '"Raleway", sans-serif'
      : '"Raleway", "Helvetica", "Arial", sans-serif',
    fontSize: active ? "1.5rem" : "1.5rem",
    fontWeight: "300",
    textTransform: "initial",
    textAlign: "center",
    zIndex: 1,
    transition: "all 0.1s ease-out",
    position: "absolute",
    top: active ? "115%" : "110%",
    left: "50%",
    transform: "translateX(-50%)",
    width: "auto",
    whiteSpace: "nowrap",
  },
  ":hover": {
    "@media (hover: hover) and (pointer: fine)": {
      "& span": {
        fontFamily: '"Raleway", sans-serif',
        fontSize: "1.5rem",
        top: "113%",
      },
      "&:before": {
        display: "block",
        opacity: !active && "0.5",
      },
    },
  },
}));

export const OptionRoundButtonImg = styled(Box)(({ theme, active }) => ({
  padding: 0,
  position: "relative",
  overflow: "hidden",
  boxSizing: "border-box",
  transition: "all 0.3s ease",
  zIndex: 0,
  width: "4rem",
  height: "4rem",
  borderRadius: "100%",
  // border: active ? "2px solid #fa0" : "2px solid transparent",
  border: active ? "2px solid #071A3D" : "2px solid transparent",
  "& img": {
    display: "block",
    position: "relative",
    width: "4rem",
    height: "4rem",
    objectFit: "cover",
    objectPosition: "center",
    margin: "auto",
    zIndex: 0,
    transition: "all 0.3s ease",
  },
  "&:hover": {
    "@media (hover: hover) and (pointer: fine)": {
      border: !active && "2px solid rgba(255, 170, 0, 1)",
    },
  },
}));

// -------------------------- Cinematic Buttons --------------------------

export const CinematicControls = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "1rem",
  position: "fixed",
  right: "auto",
  bottom: show ? 0 : "-15vh",
  top: "auto",
  left: "50%",
  transform: "translateX(-50%)",
  margin: "auto",
  zIndex: 9,
  transition: "all ease-in-out 0.5s",
  padding: "2vh 3vw 3vh",
  [theme.breakpoints.down("lg")]: {
    padding: "2vh 5vw 3vh",
  },
  [theme.breakpoints.down("md")]: {
    left: "13rem",
    transform: "none",
    bottom: "1.5rem",
    padding: 0,
    "@media (orientation: landscape)": {
      left: "auto",
      right: "24rem",
      bottom: "5vh",
    },
  },
  [theme.breakpoints.down("sm")]: {
    left: "auto",
    right: "1.8rem",
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    // background: "linear-gradient(0deg, rgba(255, 255, 255, 1) 60%, rgba(255, 255, 255, 0) 95%)",
    transition: "all linear 0.5s",
    bottom: show ? 0 : "-10vh",
    left: 0,
    righ: 0,
    zIndex: -1,
    borderRadius: "4px 4px 0 0",
    [theme.breakpoints.up("md")]: {
      bottom: show ? 0 : "-15vh",
      background:
        "linear-gradient(0deg, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 115%)",
    },
  },
}));

export const CinematicButton = styled(Button)(({ theme, active }) => ({
  width: "3.6rem",
  height: "3.6rem",
  minWidth: 0,
  minHeight: 0,
  padding: 0,
  borderRadius: "4px",
  // background: "#fa0",
  // color: "#fff",
  background: "#071A3D",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  transition: "all ease-out 0.3s 0s",
  boxSizing: "border-box",
  "& img": {
    height: "1.6rem",
    width: "auto",
    // filter: "brightness(0) invert(0)",
    filter: "brightness(0) invert(1)",
  },
  ":hover": {
    "@media (hover: hover) and (pointer: fine)": {
      // background: "rgba(255,170,0, 0.3)",
      background: "rgba(7,26,61, 0.75)",
    },
    "@media (hover: none)": {
      // background: "rgba(255,170,0, 0.3)",
      background: "rgba(7,26,61, 0.75)",
    },
  },
}));

export const ToggleMenuBtn = styled(Box)(({ theme, show }) => ({
  position: "fixed",
  left: "2rem",
  top: "2rem",
  bottom: "auto",
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 30,
  // color: "#000",
  color: "#fff",
  // background: "#fa0",
  background: "#071A3D",
  height: "auto",
  borderRadius: "0.5rem",
  boxShadow: "none",
  padding: "0.5rem 1rem 0.5rem 1rem",
  transition: show
    ? "all ease-in-out 0.4s 0, opacity 0.3s 0s ease"
    : "all ease-in-out 0.3s 0s, opacity 0.3s 0s ease",
  [theme.breakpoints.up("md")]: {
    top: "2vh",
  },
  [theme.breakpoints.down("md")]: {
    "@media (orientation: landscape)": {
      top: "17vh",
      right: "auto",
      left: "2rem",
    },
  },
  "& svg": {
    width: "1.6rem",
    transform: !show ? "none" : "rotate(180deg)",
    transition: "margin-right 0.3s ease",
    "& path": {
      stroke: "#000",
    },
  },
  "&:hover": {
    // background: show ? "rgba(255,170,0, 0.3)" : "rgba(255,170,0, 0.3)",
    background: show ? "rgba(7,26,61, 0.75)" : "rgba(7,26,61, 0.75)",
    "& svg": {
      marginRight: "0.5rem",
    },
  },
}));
